import { PROJECT_MEDIA_TYPES } from 'consts'
import { IVersionHistoryItem } from 'store/types/aiVideo'
import { IAIVideoProject } from 'types/aiVideo'
import { IBaseMediaItem } from 'types/media'

export const convertAiVideoToBaseMediaItem = (
  video?: IAIVideoProject
): IBaseMediaItem => {
  if (!video) {
    throw new Error('Video data is required')
  }

  return {
    fileName: `ai-video-${video.id}.mp4`,
    type: PROJECT_MEDIA_TYPES.aiVideo,
    originalWidth: video.width!,
    originalHeight: video.height!,
    path: video.videoUrl,
    duration: video.videoDurationSeconds,
    assetId: String(video.id),
    thumbnail: video.thumbnail,
    imageUrl: video.imageUrl
  }
}

export const convertHistoryVideoVersionToBaseMediaItem = (
  video?: IVersionHistoryItem
): IBaseMediaItem => {
  if (!video) {
    throw new Error('Video data is required')
  }

  return {
    type: PROJECT_MEDIA_TYPES.aiVideo,
    path: video.url,
    fileName: `ai-video-${video.id}.mp4`,
    originalWidth: video.width ?? 0,
    originalHeight: video.height ?? 0,
    duration: video.durationSeconds ?? 0,
    assetId: String(video.id),
    thumbnail: video.thumbnailUrl
  }
}
